__turbopack_context__.v({
  "bottom": "styles-module-scss-module__MIuCTa__bottom",
  "footer": "styles-module-scss-module__MIuCTa__footer",
  "iconContainer": "styles-module-scss-module__MIuCTa__iconContainer",
  "links": "styles-module-scss-module__MIuCTa__links",
  "logo": "styles-module-scss-module__MIuCTa__logo",
  "srOnly": "styles-module-scss-module__MIuCTa__srOnly",
  "top": "styles-module-scss-module__MIuCTa__top",
});
